import { createFileRoute } from "@tanstack/react-router";
import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { serviceBySlug } from "@/data/services";
import { breadcrumbSchema, faqSchema, jsonLd, serviceSchema, absUrl } from "@/lib/seo";

const service = serviceBySlug["herrklippning-skaggtrimning"];
const CANONICAL = "/herrklippning-skaggtrimning";

export const Route = createFileRoute("/herrklippning-skaggtrimning")({
  head: () => ({
    meta: [
      { title: service.seoTitle },
      { name: "description", content: service.metaDescription },
      { property: "og:title", content: service.seoTitle },
      { property: "og:description", content: service.metaDescription },
      { property: "og:url", content: absUrl(CANONICAL) },
      { property: "og:type", content: "article" },
    ],
    links: [{ rel: "canonical", href: absUrl(CANONICAL) }],
    scripts: [
      jsonLd(serviceSchema(service)),
      jsonLd(faqSchema(service.faq)),
      jsonLd(
        breadcrumbSchema([
          { name: "Hem", url: "/" },
          { name: "Tjänster", url: "/herrklippning" },
          { name: service.shortName, url: service.url },
        ]),
      ),
    ],
  }),
  component: () => <ServicePageTemplate service={service} />,
});
